import { IApplicationState } from '../../types/redux';

export function getNewbuildingById(state: IApplicationState, newbuildingId: number) {
  const { newbuildings, similarNewbuildings = [] } = state.offersData;

  return [...newbuildings, ...similarNewbuildings].find(item => item.id === newbuildingId);
}
